module.exports = __webpack_public_path__ + "static/media/T29.8f355621.jpg";